"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorksiteStatus = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var isVisible_1 = require("utils/isVisible");
var JobsList_1 = require("./JobsList");
var AddJobModal_1 = require("./AddJobModal");
var dispatchers_1 = require("./utils/dispatchers");
require("./style.scss");
var jobTools_1 = require("./utils/jobTools");
var jobStatusList = ['STARTED', 'IN_PROGRESS', 'DONE', 'ON_HOLD'];
var WorksiteStatus = function (props) {
    var _a = React.useState(false), openAddJobModal = _a[0], setOpenAddJobModal = _a[1];
    var _b = React.useState('ON_HOLD'), selectedJobStatus = _b[0], setSelectedJobStatus = _b[1];
    var _c = React.useState(), selectedJobIndex = _c[0], setSelectedJobIndex = _c[1];
    var _d = React.useState(false), mobileButtons = _d[0], setMobileButtons = _d[1];
    var ref = React.useRef(null);
    var inViewport = (0, isVisible_1.isVisible)(ref, '0px');
    var currentEntryJobs = (0, react_redux_1.useSelector)(function (state) { return state.diaryentries.jobs; });
    var dispatchers = (0, dispatchers_1.mapDispatchers)((0, react_redux_1.useDispatch)());
    React.useEffect(function () {
        return function () {
            dispatchers.clearState();
        };
    }, []);
    React.useEffect(function () {
        props.setJobsList(currentEntryJobs.jobs);
    }, [currentEntryJobs]);
    React.useEffect(function () {
        if (!inViewport && mobileButtons) {
            setMobileButtons(false);
            setSelectedJobIndex(undefined);
        }
    }, [mobileButtons, inViewport]);
    return (React.createElement("div", { className: "diaryentry-worksite-status", ref: ref },
        React.createElement(sok_ui_1.Panel, { title: (0, translation_1.getLocalization)('diaryEntryView/worksiteStatus') },
            !props.isMobile && props.viewportSize !== 'TABLET' && (React.createElement("div", { className: "add-button" },
                React.createElement(sok_ui_1.Button, { icon: React.createElement(sok_ui_1.Icon, { className: "fa-plus" }), size: "large", color: "green", disabled: props.isDisabled, onClick: function () {
                        setOpenAddJobModal(true);
                        setSelectedJobStatus('STARTED');
                    } }, (0, translation_1.getLocalization)('diaryEntryView/worksiteStatus/add')))),
            React.createElement(AddJobModal_1.default, { show: openAddJobModal, update: false, jobs: props.jobs, setJobsList: props.setJobsList, jobStatus: selectedJobStatus, setJobStatus: setSelectedJobStatus, updateJob: jobTools_1.updateJob, isDisabled: props.isDisabled, closeModal: function () { return setOpenAddJobModal(false); } }),
            jobStatusList.map(function (jobStatus) { return (React.createElement(JobsList_1.default, { perm: props.perm, key: jobStatus, status: jobStatus, jobs: props.jobs, selectedJobStatus: selectedJobStatus, isDisabled: props.isDisabled, isMobile: props.isMobile, viewportSize: props.viewportSize, currentEntry: props.currentEntry, currentWorksiteDiary: props.currentWorksiteDiary, setSelectedJobStatus: setSelectedJobStatus, setJobsList: props.setJobsList, updateJob: jobTools_1.updateJob, deleteJob: jobTools_1.deleteJob, openAddJobModal: setOpenAddJobModal, mobileButtons: mobileButtons, setMobileButtons: setMobileButtons, selectedJobIndex: selectedJobIndex, setSelectedJobIndex: setSelectedJobIndex })); }))));
};
exports.WorksiteStatus = WorksiteStatus;
